import { getMessages } from '../../../../../../store/constants';

export const BOARD_SECTION_COLORS = getMessages().getText('board_settings.colors.title');
